import { PayrollTypeEnum } from "@gtpl/shared-models/hrms";
import { ApiProperty } from "@nestjs/swagger";

export class EmployeeIdReq{
    @ApiProperty()
    employeeId: any
    @ApiProperty()
    month: number
    @ApiProperty()
    employeeType: string
    @ApiProperty()
    employeeCategory
}